module.exports = __webpack_public_path__ + "img/ANGEL SHADES GREEN.0f04cb7.svg";